<template>
  <div class="login-wrap login-main">
    <div class="ms-login">
        <div class="ms-title">护士站</div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm" label-width="0px" class="ms-content">
            <el-form-item prop="mobile">
                <el-input
                  type="text"
                  v-model="ruleForm.mobile"
                  maxlength="11"
                  @keyup.enter.native="submitForm('ruleForm')"
                  autocomplete="off">
                    <el-button tabindex="-1" slot="prepend" icon="el-icon-user"></el-button>
                </el-input>
            </el-form-item>
            <el-form-item prop="password">
                <el-input
                  type="password"
                  v-model="ruleForm.password"
                  maxlength="24"
                  @keyup.enter.native="submitForm('ruleForm')"
                  autocomplete="off">
                    <el-button tabindex="-1" slot="prepend" icon="el-icon-lock"></el-button>
                </el-input>
            </el-form-item>
            <div class="login-btn">
              <el-button
                type="primary"
                @click="submitForm('ruleForm')"
                v-loading.fullscreen.lock="fullscreenLoading"
              >登录</el-button>
            </div>
        </el-form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  computed: {
    ...mapState(["LoginInfo"])
  },
  watch: {
    "LoginInfo.signerror"(val) {
      if (val) {
        this.$message({
          offset: window.innerHeight - 200,
          showClose: true,
          message: val,
          type: "error",
          center: true
        });
        this.fullscreenLoading = false;
      }
    },
    "LoginInfo.signed"(val) {
      if (val) {
        this.$router.replace({ name: "Home" });
        this.fullscreenLoading = false;
      }
    }
  },
  data() {
    var validAccount = (rule, value, callback) => {
      var reg = /1[0-9]{10}$/;
      console.log(value, reg.test(value));
      if (!reg.test(value) && value !== 'admin') {
        callback(new Error("请输入合法账号"));
      }
      callback();
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      }
      callback();
    };
    return {
      ruleForm: {
        mobile: "",
        password: ""
      },
      rules: {
        mobile: [{ validator: validAccount, trigger: "blur" }],
        password: [{ validator: validatePass, trigger: "blur" }]
      },
      fullscreenLoading: false
    };
  },
  methods: {
    ...mapActions([
      "login" // map `this.login()` to `this.$store.dispatch('login')`
    ]),
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const ruleForm = {
            ...this.ruleForm,
            password: this.$md5(this.ruleForm.password)
          };
          this.fullscreenLoading = true;
          this.login(ruleForm);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  },
  created() {
  },
  mounted() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.login-main {
  width: 100%;
  height: 100%;
  padding-top: 50px;
}

.login-wrap {
    position: relative;
    width: 100%;
    height: 100%;
    background-size: 100%;
}
.ms-title {
    width: 100%;
    line-height: 50px;
    text-align: center;
    font-size: 20px;
    color: #fff;
    border-bottom: 1px solid #ddd;
}
.ms-login {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 350px;
    margin: -190px 0 0 -175px;
    border-radius: 5px;
    background: rgba(255, 255, 255, 0.3);
    overflow: hidden;
}
.ms-content {
    padding: 30px 30px;
}
.login-btn {
    text-align: center;
}
.login-btn button {
    width: 100%;
    height: 36px;
    margin-bottom: 10px;
}
.login-tips {
    font-size: 12px;
    line-height: 30px;
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue